import axios from 'axios'
import usuarioHelper from '@/helpers/usuario-logado';

export default {
  registrar: function (descricao, protocolo, cliente) {
    axios.post(`${process.env.URL_QUESTIONARIOMS}/v1/salvaRegistroAuditoria`, {
      descricao: descricao,
      usuario: usuarioHelper.USUARIO_LOGADO().nome,
      protocolo: protocolo,
      cliente: cliente
    }, {
        headers: {
          'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
  }
}


// WEBPACK FOOTER //
// ./src/helpers/auditoria.js